import React from 'react';

import { AIGiftAssistantTemplate } from '@hero/components';

export default function Page() {
  return <AIGiftAssistantTemplate />;
}
